import { ConversionType } from "traveldesk-ui"

export default class AccountSettingsCurrenciesModel {
    baseCurrency: string = "AED"
    secondaryCurrency: string = "$"
    convRate: number = 1
    convType: ConversionType = ConversionType.DEV
}